import { Container, Grid } from "@material-ui/core";
import axios from "../../axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ExchangeSingleMarketHeader from "./ExchangeSingleMarketHeader";
import ExchangeSingleMarketTabel from "./ExchangeSingleMarketTable";

function ExchangeBoardSingleMarket() {
  const { exchangeId } = useParams();
  const [data, setData] = useState();

  useEffect(() => {
    setInterval(() => {
      axios
        .get(`/exchanges/${exchangeId.toLowerCase()}`)
        .then((res) => {
          setData(res.data.data);
        })
        .catch((err) => console.log(err));
    }, 3000);
  }, []);

  return (
    <Container fixed>
      <Grid container justify="center">
        <Grid item xs={12}>
          <ExchangeSingleMarketHeader data={data} />
        </Grid>
        <Grid item>
          <ExchangeSingleMarketTabel exchangeId={exchangeId.toLowerCase()} />
        </Grid>
      </Grid>
    </Container>
  );
}

export default ExchangeBoardSingleMarket;
